/**
 * Onboarding Utilities
 *
 * Helper functions for checking and managing onboarding completion
 */

/**
 * Check if contractor has completed required onboarding
 * @param {Object} contractor - Contractor object from database
 * @returns {boolean} True if all required fields are filled
 */
export function isOnboardingComplete(contractor) {
  if (!contractor) return false;

  return !!(
    contractor.company_name &&
    contractor.contact_email &&
    contractor.office_address &&
    contractor.office_city &&
    contractor.office_state &&
    contractor.office_zip &&
    contractor.climate_zone
  );
}

/**
 * Get list of missing required fields
 * @param {Object} contractor - Contractor object from database
 * @returns {Array} Array of missing field labels
 */
export function getMissingFields(contractor) {
  if (!contractor) return [];

  const missing = [];

  if (!contractor.company_name) missing.push('Company Name');
  if (!contractor.contact_email) missing.push('Contact Email');
  if (!contractor.office_address) missing.push('Office Address');
  if (!contractor.office_city) missing.push('City');
  if (!contractor.office_state) missing.push('State');
  if (!contractor.office_zip) missing.push('Zip Code');
  if (!contractor.climate_zone) missing.push('Climate Zone');

  return missing;
}

/**
 * Calculate onboarding completion percentage
 * @param {Object} contractor - Contractor object from database
 * @returns {number} Percentage complete (0-100)
 */
export function getOnboardingProgress(contractor) {
  if (!contractor) return 0;

  const totalFields = 7;
  const completedFields = [
    contractor.company_name,
    contractor.contact_email,
    contractor.office_address,
    contractor.office_city,
    contractor.office_state,
    contractor.office_zip,
    contractor.climate_zone
  ].filter(Boolean).length;

  return Math.round((completedFields / totalFields) * 100);
}
